
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"36","height":"36","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"36","height":"36","rx":"8","fill":"#1937A3"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M22.462 10.493a6.5 6.5 0 017.085 10.604l-8.84 8.84a1 1 0 01-1.414 0l-8.84-8.84a6.501 6.501 0 019.194-9.194l.353.353.353-.353a6.501 6.501 0 012.109-1.41zm2.488 1.505a4.5 4.5 0 00-3.183 1.319l-1.06 1.06a1 1 0 01-1.414 0l-1.06-1.06a4.501 4.501 0 10-6.366 6.366L20 27.816l8.133-8.133a4.502 4.502 0 00-3.183-7.685z","fill":"#fff"}})])
          )
        }
      }
    